<template>
    <v-layout v-if="qrcode" column align-center justify-center align-content-center>
        <qrcode :value="qrcode" :options="{ width: 300 }"></qrcode>
        <h3>{{$t('qrcode_show_message')}}</h3>
    </v-layout>
</template>

<script>
    export default {
        name: "QRCode",
        data: () => ({
            qrcode: null
        }),
        mounted() {
            this.username = this.$store.state.authentication.user.username;
            this.qrcode = this.username.split('-')[1];
        },
    }
</script>

<style scoped>

</style>